export default __webpack_public_path__ + "static/media/8osissm.aadaeffd.webp";